import styled from 'styled-components';

export const SuspendedStatus = styled.div`
   width: 131px;
    height: 42px;
    border-radius: 16px;
    border: 1px solid #858585;
    background: rgba(209, 209, 209, 0.7);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 9px 30px 9px 30px;

    text-align: center;
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
`